export enum TrailerTypes {
    Reefer = 1,
    Dry = 2,
    NA = 3,
}
